import React, { Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { connectorApi } from '@app/store';
import { IConnector, ConnectorCreateDTO } from '@app/common';
import { Button, CardButtonActionMode, Form, Panel } from '@app/components';
import { ConnectorForm } from './ConnectorForm';
import { useToast, useTriptych } from '@app/hooks';
import { ConnectorCard } from './ConnectorCard';

interface ConnectorCreateProps {
  toggle: (mode: CardButtonActionMode) => void;
}

export const ConnectorCreate = ({ toggle }: ConnectorCreateProps) => {
  const toast = useToast();

  const triptych = useTriptych();

  const [create, { isLoading, error: apiErrors }] = connectorApi.useCreateOneConnectorsMutation();

  const formMethods = useForm<Partial<IConnector>>({
    resolver: classValidatorResolver(ConnectorCreateDTO),
    defaultValues: {
      name: '',
      description: '',
      autoPublish: false,
      type: undefined,
    }
  });

  const onCreate = async (formValues: Partial<IConnector>) => {
    try {
      const connector = await create(formValues).unwrap();

      triptych.close({ mode: 'UPDATE', data: connector });

      toast.success('Votre connecteur a bien été créé.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre connecteur.')
    }
  }

  return (
    <Fragment>
      <ConnectorCard
        formMethods={formMethods}
        toggle={toggle} />

      <Panel.Content>

        <Form formMethods={formMethods} apiErrors={apiErrors}>

          <Panel.FormContainer>

            <ConnectorForm withType />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              title="Valider"
              grow
              large />
          </Panel.Actions>
        </Form>
      </Panel.Content>
    </Fragment>
  );
};
